import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin } from "rxjs";
import { Agent, Organization, OrganizationClient, ServiceRequest, ServiceRequestClient } from "src/app/web-api-client";
import { WtStorageService } from "src/app/wt-storage.service";
import { OrganizationalTypes } from "../../enums/organizational-types.enum";
import { CreateTaxSettlementComponent } from "../create-tax-settlement/create-tax-settlement.component";
import { ServiceRequestStatusHelper } from "../../shared/enum/serviceRequestStatus.enum";
import { ServiceRequestResponseTypeUtil } from "src/app/shared/utils/service-request-response.utils";


@Component({
  selector: 'app-service-request-list',
  templateUrl: './service-request-list.component.html',
  styleUrls: ['./service-request-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceRequestListComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedService: ServiceRequest;
  public services: ServiceRequest[];
  public currentAgent: Agent;
  public orgs: Organization[] = [];


  constructor(private readonly changeDetectionRef: ChangeDetectorRef, private readonly modalService: NgbModal,public orgClient:OrganizationClient, public localStore: WtStorageService, public client: ServiceRequestClient) {

    this.currentAgent = localStore.getАgent();
  }

  ngOnInit(): void {

    this.loadData();

  }


  private loadData() {
    this.isLoaded = false;
    forkJoin([this.client.getList(), this.orgClient.getList()])
      .subscribe(([allServices, allOrgs]) => {

        this.orgs = allOrgs;
        this.services = allServices;
        this.isLoaded = true;
        this.changeDetectionRef.detectChanges();

      });
  }

  public onSelected(service: ServiceRequest) {
    if (this.isSelected(service)) {
      this.selectedService = null;
    }
    else {

      this.selectedService = service;
    }
  }

  public isSelected(service: ServiceRequest): boolean {
    return this.selectedService == service;
  }

  public getAgentName(serviceRequest: ServiceRequest) {
    return serviceRequest.agentService ? serviceRequest.agentService.agent.agentName : this.currentAgent.agentName;
  }

  public getAgentComission(serviceRequest: ServiceRequest) {
    return serviceRequest.serviceAgentComission;
  }

  public onCreation(): void {

  }


  public onDelete(): void {



  }

  public onEdit(): void {

  }

  public getRequestorNames(serviceRequest: ServiceRequest) {
    return `${serviceRequest.firstName} ${serviceRequest.fammily}`
  }

  public isSumTaxSettlement(serviceRequest: ServiceRequest) {
    return serviceRequest.isSettlementGenerated ? 'Да' : 'Не';
  }

  isGlobalOrg() {

    return this.localStore.getuser().organization.organizationalType == OrganizationalTypes.Global;
  }

  getGlobalOrg(service: ServiceRequest) {
    let org = this.orgs.find(d => d.id == service.organizationId);
    return org ? org.title : 'Няма Организация';
  }

  getShippingMethodName(service: ServiceRequest) {
    return service.shippingMethod ? service.shippingMethod.name : '-';
  }

  getDeliveredDate(service: ServiceRequest) {
    return service.deliveredDate ? new Date(service.deliveredDate).toLocaleDateString('bg-BG') : '-';
  }

  getServiceName(service:ServiceRequest) {
    return service.deliverService.service.serviceName;
  }

  getDate(service: ServiceRequest): string {
    const date = new Date(service.dateReg);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() returns 0-11
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  }

  public getTranslatedStatus(status: number): string {
    return ServiceRequestStatusHelper.GetCyrilicName(status);
  }

  getURI(service: ServiceRequest) {
    return service.deliverService.service.yri;
  }
  openTaxSettlementModal() {
    const modalRef = this.modalService.open(CreateTaxSettlementComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.services = this.services.filter(d=>d.organizationId == this.localStore.getuser().organizationId);
    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();
    });




    modalRef.result.then((result) => {
      // Handle the result from the modal
    }, (reason) => {
      // Handle the dismissal of the modal
    });
  }

  public GetResponseType(serviceRequest: ServiceRequest) {
    return ServiceRequestResponseTypeUtil.getCyrilicLabel(serviceRequest.responseType);
  }
}
